import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Class name merger — combines clsx for conditional classes with
 * tailwind-merge for proper Tailwind dedup (e.g., `px-2 px-4` → `px-4`).
 * Standard shadcn utility.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
